
// // Pic For : ✅ Single Select
// {/* <CustomSelect
//   options={options}
//   value={value}
//   setValue={setValue}
// /> */}

// // Pic For : ✅ Multi Select
// // <CustomSelect
// //   isMulti
// //   options={options}
// //   value={value}
// //   setValue={setValue}
// // />

// // Pic For : ✅ Creatable Single Select
// {/* <CustomSelect
//   isCreatable
//   options={options}
//   setOptions={setOptions}
//   value={value}
//   setValue={setValue}
// /> */}

// // Pic For : ✅ Creatable Multi Select (Workspace case)
// {/* <CustomSelect
//   isMulti
//   isCreatable
//   options={options}
//   setOptions={setOptions}
//   value={value}
//   setValue={setValue}
//   name="workspaces"
//   input={form}
//   setInput={setForm}
// /> */}

import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";

const normalize = (value) => value.trim().toLowerCase();

const CustomSelect = ({
  options,
  setOptions,
  value,
  setValue,

  input,
  setInput,

  isMulti = false,
  isCreatable = false,
  isDisabled = false,
  isClearable = true,

  placeholder = "Select...",
  name,
}) => {
  const Component = isCreatable ? CreatableSelect : Select;

  const updateFormState = (selected) => {
    if (!setInput || !name) return;

    const fieldValue = isMulti
      ? (selected || []).map((i) => i.value).join(",")
      : selected?.value || "";

    setInput((prev) => ({
      ...prev,
      [name]: fieldValue,
      errors: {
        ...prev.errors,
        [name]: "",
      },
    }));
  };

  const handleChange = (selected) => {
    if (isMulti) {
      const uniqueMap = new Map();
      (selected || []).forEach((item) => {
        uniqueMap.set(normalize(item.value), item);
      });

      const uniqueSelection = Array.from(uniqueMap.values());
      setValue(uniqueSelection);
      updateFormState(uniqueSelection);
    } else {
      setValue(selected);
      updateFormState(selected);
    }
  };

  const handleCreate = (inputValue) => {
    if (!setOptions) return;

    const cleanValue = inputValue.trim();
    if (!cleanValue) return;

    const normalizedValue = normalize(cleanValue);

    const alreadyExists = options.some(
      (opt) => normalize(opt.value) === normalizedValue,
    );

    if (alreadyExists) {
      toast.error("Value already exists");
      return;
    }

    const newOption = {
      label: cleanValue,
      value: cleanValue,
    };

    setOptions((prev) => [...prev, newOption]);

    if (isMulti) {
      const updated = [...(value || []), newOption];
      setValue(updated);
      updateFormState(updated);
    } else {
      setValue(newOption);
      updateFormState(newOption);
    }
  };

  return (
    <Component
      isMulti={isMulti}
      isClearable={isClearable}
      isDisabled={isDisabled}
      placeholder={placeholder}
      options={options}
      value={value}
      onChange={handleChange}
      onCreateOption={isCreatable ? handleCreate : undefined}
      maxMenuHeight={180}
    />
  );
};

export default CustomSelect;
